import { useNavigate } from "react-router";
import { useEffect } from "react";

export const SESSION_STORAGE_LOGIN_REDIRECT_URI = "pp";

function CallbackRoute() {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUri = sessionStorage.getItem(
      SESSION_STORAGE_LOGIN_REDIRECT_URI,
    );
    if (redirectUri) {
      sessionStorage.removeItem(SESSION_STORAGE_LOGIN_REDIRECT_URI);
      navigate(redirectUri);
    } else {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [navigate]);

  return <></>;
}

export default CallbackRoute;
